// extracted by mini-css-extract-plugin
export default {"row-action":"UploadProduct_row-action__Wndtn"};